module.exports = "https://bin.bnbstatic.com/_next/static/images/step2-58a4620e78156677097a4fbfc0ed1af4.png";